import {Pipe, PipeTransform} from '@angular/core';
import {Pushpin} from '../classes/pushpin.class';
import {Settings} from '../settings.class';
import {StatusService} from '../services/status/status.service';

@Pipe({
    name: 'pushpinIcon'
})
export class PushpinIconPipe implements PipeTransform {
    constructor(private statusService: StatusService) {
    }

    transform(pushpin: Pushpin, mapStyleRoad: boolean = true): any {
        const parser = new DOMParser();

        let color1 = 'FF0000';
        let color2 = 'FF0000';

        if (pushpin.pushpin_parts && this.statusService) {
            const heaviestStatuses = this.statusService.getHeaviestStatuses(pushpin.pushpin_parts);
            if (heaviestStatuses.length !== 0) {
                color1 = heaviestStatuses[0].color;
                if (heaviestStatuses.length === 2) {
                    color2 = heaviestStatuses[1].color;
                } else {
                    color2 = heaviestStatuses[0].color;
                }
            }
        }
        let svg = pushpin.lengthmark ? Settings.getLineMarker(pushpin.number, pushpin.number, color1, color2, mapStyleRoad) : Settings.getMarker(pushpin.number, pushpin.number, color1, color2, mapStyleRoad);
        svg = svg.replace(/^<\?xml.*?\?>/, '');

        return parser.parseFromString(svg, 'image/svg+xml').documentElement;
    }
}
